export default msTimeout => {
	return new Promise(resolve => {
		setTimeout(() => {
			resolve()
		}, msTimeout)
	})
}
